module.exports = __webpack_public_path__ + "static/media/sword.c8943c9b.svg";